import Dialog from 'components/Dialog';
import { useLanguage } from 'context/AppContext';

type Props = {
  onConfirm?: () => void;
  onCancel?: () => void;
};

export const ConfirmAnotherDecantedTrayDialog = ({ onConfirm, onCancel }: Props) => {
  const lang = useLanguage()[0].ConfirmAnotherDecantedTrayDialog;

  return (
    <Dialog
      open
      title={lang.title}
      confirmLabel={lang.confirm}
      cancelLabel={lang.cancel}
      allowClose={false}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
